import { render, staticRenderFns } from "./CustomIde.vue?vue&type=template&id=3a04eaf0&scoped=true"
import script from "./CustomIde.vue?vue&type=script&lang=js"
export * from "./CustomIde.vue?vue&type=script&lang=js"
import style0 from "./CustomIde.vue?vue&type=style&index=0&id=3a04eaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04eaf0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapLocationMap: require('/opt/atlassian/pipelines/agent/build/components/Map/LocationMap.vue').default,MapIdeFilters: require('/opt/atlassian/pipelines/agent/build/components/Map/ide/Filters.vue').default})
